module.exports = __webpack_public_path__ + "static/media/head-road.72042c78.png";